import { render, staticRenderFns } from "./ConferenciaResumoServico.vue?vue&type=template&id=71085994"
import script from "./ConferenciaResumoServico.vue?vue&type=script&lang=js"
export * from "./ConferenciaResumoServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports